import { render, staticRenderFns } from "./Auth_PromptLabel.vue?vue&type=template&id=478de60b&scoped=true&"
import script from "./Auth_PromptLabel.vue?vue&type=script&lang=js&"
export * from "./Auth_PromptLabel.vue?vue&type=script&lang=js&"
import style0 from "./Auth_PromptLabel.vue?vue&type=style&index=0&id=478de60b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478de60b",
  null
  
)

export default component.exports